module.exports = __webpack_public_path__ + "static/media/us.ce0b3115.svg";